export default {
    setCustomers(state, customers) {
        state.customers = customers;
    },
    setActiveCustomer(state, customer) {
        state.activeCustomer = customer;
    },
    setManageCustomerDialog(state, status) {
        state.manageCustomerDialog = status;
    },
    setDeleteCustomerDialog(state, status) {
        state.deleteCustomerDialog = status;
    }
}
